import { page } from '$app/stores';
import { derived, get, type Invalidator, type Subscriber, type Unsubscriber } from 'svelte/store';
import { parse, stringify } from 'qs';
import { goto } from '$app/navigation';

// use singleton store for better perfonmance
const fromPage = derived(page, ($page) => {
	const q = parse($page.url.search, {
		ignoreQueryPrefix: true
	});
	return q;
});

const set = (newQ: any) => {
	goto(
		`?${stringify(newQ, {
			arrayFormat: 'brackets'
		})}`
	);
};

const update = (updater: (old: any) => any) => {
	const old = get(fromPage);
	const newQ = updater(old);
	set(newQ);
};

const update1 = (name: string, value: any) => {
	update((old) => ({ ...old, [name]: value }));
};

const del = (name: string) => {
	update((old) => {
		const newQ = { ...old };
		delete newQ[name];
		return newQ;
	});
};

const clear = () => {
	set({});
};

const urlQ = {
	subscribe: fromPage.subscribe,
	set,
	update,
	update1,
	del,
	clear
};

export const useUrlQ = <PK extends string>() => {
	type AR = { [K in PK as K extends `${infer _A}[]` ? _A : never]: string[] | null };
	type S = { [K in PK as K extends `${string}[]` ? never : K]: string | null };

	// all keys identified
	type Q = AR & S;

	return {
		urlQ: urlQ as unknown as {
			subscribe: (
				this: void,
				run: Subscriber<Q>,
				invalidate?: Invalidator<Q> | undefined
			) => Unsubscriber;
			set: (newQ: Partial<Q>) => void;
			update: (updater: (old: Q) => Partial<Q>) => void;
			update1: <K extends keyof Q>(name: K, value: Q[K]) => void;
			del: (name: keyof Q) => void;
			clear: () => void;
		}
	};
};
